
import mixin from '@/mixins'
import swiperBox from './components/swiper'
import qrDialog from './components/Dialog'
import indexFooter from './components/indexFooter'
import { MainApi } from '@/api'
import Util from '@/common/js/util'
import Popup from 'vux/src/components/popup/index.vue'


const echarts = require('echarts/lib/echarts')

require('echarts/lib/chart/pie')

require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')

export default {
name: 'myPlan',
mixins: [mixin],
components: {
indexFooter,
swiperBox,
Popup,
qrDialog,
},
data() {
return {
popupShow: false,
popupObj: {
jijin: '',
licai: '',
jiegou: '',
},
canvasH: 2750,
canvasW: 750,
isCanvasShows: false,
myChart: null,
overUrl: '',
isOverPicShows: false,
id: '',
allData: {},
commentArr: ['低目标', '合理目标', '高目标'],
tagArr: [
'咖啡不用断，衣服继续买，轻松成为人生赢家',
'稍微削减高开支，就能拥有自己的小套间',
'勒紧裤腰带，不但减肥还能实现财务自由',
],
sumFinalIncome: '', //总的收益
yearIncomeArr: [], //每个收益提取出来
yearIncomeList: [], //把收益计算为 每年
yearIncomeChildArr: [], //收益每年下面的swiper提取其中1个
yearProductArr: [], //返回滑动后的所有产品名
yearProductList: [], //返回滑动后的当前产品名
getSwiperData: {}, //获取滑动的siweper返回的数据
DepositAmountNum: '', //存款合计
jijinIncome: '', //基金收益
jiegouIncome: '', //结构性收益
licaiIncome: '', //理财收益
DepositAmountArr: [], //年的 存款合计列表
fixedDepositAmountArr: [], //年的 存款合计列表
DepositChildArr: [], //基础的收益增减数详情
swperDepositIncomeList: [], //基础的收益按swipe分组
isQrShows: false,
qrImg: '',
}
},
created() {
this.id = this.$route.query.id
this.getDetailsFn()
},
mounted() {},

methods: {
getChangeCloseFn() {
this.isQrShows = false
},
showDialogQrFn(url) {
this.qrImg = url
this.isQrShows = true
},

getDetailsFn() {
MainApi.getUserDepositPlanDetails({
id: this.id,
})
.then(data => {
console.log('data', data)
if (data.Status === 200) {
this.allData = data.Result
this.sumFinalIncome = this.allData.FinalIncome
this.DepositAmountNum = this.allData.FinalDeposit
this.licaiIncome = this.allData.IncomeDetail.FinalLicaiIncome
this.jiegouIncome = this.allData.IncomeDetail.FinalJiegouIncome
this.jijinIncome = this.allData.IncomeDetail.FinalFundIncome

this.drawCharts() 



this.allData.list.forEach((item, idx) => {


this.$set(this.yearIncomeArr, idx, [])
this.$set(this.yearIncomeList, idx, item.EstimatedRevenue)
this.$set(this.yearProductArr, idx, [])
this.$set(this.yearProductList, idx, [])
this.$set(this.DepositAmountArr, idx, item.TotalDeposits)
this.$set(this.fixedDepositAmountArr, idx, item.TotalDeposits)

item.Detail.forEach((el, key) => {
this.$set(this.yearIncomeArr[idx], key, [])
this.$set(this.yearProductArr[idx], key, [])
this.$set(this.yearProductList[idx], key, '')

el.forEach((v, i) => {
this.$set(this.yearIncomeArr[idx][key], i, [])
this.$set(this.yearIncomeArr[idx][key], i, v.Income)


this.$set(this.yearProductArr[idx][key], i, [])

if (v.Type == 1) {
this.$set(this.yearProductArr[idx][key], i, v.Name)

this.yearProductList[idx][key] = el[0].Name
} else {
this.$set(
this.yearProductArr[idx][key],
i,
v.BankName + '&' + v.ProductName,
)

this.yearProductList[idx][key] =
el[0].BankName + '&' + el[0].ProductName





}
})

})
})







let newArr = []
let DepositNewArr = []
let swperDepositIncomeList = []
this.yearIncomeArr.forEach((item, idx) => {
DepositNewArr[idx] = []
swperDepositIncomeList[idx] = []
newArr[idx] = []
item.forEach((v, k) => {
swperDepositIncomeList[idx][k] = 0
DepositNewArr[idx][k] = []
DepositNewArr[idx][k][0] = 0
newArr[idx][k] = v[0]
for (let index = 1; index < v.length; index++) {
DepositNewArr[idx][k][index] = +(v[index] - v[0]).toFixed(2)

}
})
})
this.yearIncomeChildArr = newArr
this.DepositChildArr = DepositNewArr
this.swperDepositIncomeList = swperDepositIncomeList 
























} else {
this.$vux.toast.text(data.Result.ErrorMsg, 'top')
}
})
.catch(() => {
this.$vux.loading.hide()
})
},
drawPicFn() {





this.$vux.loading.show({
text: '正在生成...',
})

let canvasH = 1450
let rectangle2H = 180 

switch (this.yearProductList.length) {
case 2:
canvasH = 1750
rectangle2H = 480
break
case 3:
canvasH = 1750 + 380
rectangle2H = 480 + 380
break
case 4: //4-5年
canvasH = 1750 + 380 * 2
rectangle2H = 480 + 380 * 2
break
case 5: //6-7年
canvasH = 1750 + 380 * 3
rectangle2H = 480 + 380 * 3
break
case 6: //8-9年
canvasH = 1750 + 380 * 4 + 30
rectangle2H = 480 + 380 * 4 + 30
break
case 7: //10-11年
canvasH = 1750 + 380 * 5 + 30
rectangle2H = 480 + 380 * 5 + 30
break
case 8: //12-13年
canvasH = 1750 + 380 * 6 + 60
rectangle2H = 480 + 380 * 6 + 60
break
case 9: //14-15年
canvasH = 1750 + 380 * 7 + 90
rectangle2H = 480 + 380 * 7 + 90
break
default:
break
}

const myCanvas = this.$refs.canvas
const ctx = myCanvas.getContext('2d')
myCanvas.height = canvasH
ctx.fillStyle = '#F6F7F8'
ctx.fillRect(0, 0, this.canvasW, canvasH)
let bgImg = new Image()
bgImg.src = this.$refs.bgPic.src

bgImg.onload = () => {
ctx.drawImage(bgImg, 0, 0, this.canvasW, 610)
let titleImg = new Image()
titleImg.src = this.$refs.titlePic.src
titleImg.onload = () => {
ctx.drawImage(titleImg, 102, 117, 546, 104)

let chartImg = new Image()

chartImg.src = this.myChart.getDataURL({
pixelRatio: 3,
backgroundColor: '#fff',
})



chartImg.onload = () => {

const textStartX = 50
this.drawMaxTitleFn(ctx, '结果展示', 300)


this.fillRoundRect(ctx, 25, 350, 700, 680, 8, '#fff')


ctx.drawImage(chartImg, textStartX, 600, 650, 400)

let tagBgColor =
this.allData.Type == 1
? '#52CE95'
: this.allData.Type == 2
? '#ee9b35'
: '#e75446'
this.fillRoundRect(ctx, textStartX, 380, 130, 46, 4, tagBgColor)
ctx.font = 'normal 25px  sans-serif'
ctx.textAlign = 'center'
ctx.fillText(this.commentArr[this.allData.Type - 1], 115, 392)

ctx.textAlign = 'left'
const earningsNum = '￥' + this.sumFinalIncome 
const depositNum = '￥' + this.DepositAmountNum 
const monthIntoNum = this.allData.MonthlyDeposit 


ctx.fillStyle = '#333'
ctx.fillText('预计收益：', textStartX, 460)

ctx.fillText('存款合计：', textStartX, 510)

ctx.fillStyle = '#E75446'

ctx.fillText(earningsNum, 180, 460)
ctx.fillText(depositNum, 180, 510)

ctx.fillStyle = '#333'
ctx.font = 'normal 26px  sans-serif'
ctx.fillText(
'每月存款：' +
monthIntoNum +
'元   存款年限：' +
this.allData.TargetDuration +
'年',
200,
390,
)

ctx.moveTo(textStartX, 560) 
ctx.lineTo(700, 560) 
ctx.lineWidth = 1 
ctx.strokeStyle = '#DEDEDE' 
ctx.stroke()

ctx.font = 'bold 25px  sans-serif'
ctx.fillText('收益组合', textStartX, 585)

ctx.font = 'normal 25px  sans-serif'
ctx.fillStyle = '#999'

ctx.fillText(
'评价：' + this.tagArr[this.allData.Type - 1],
textStartX,
985,
)

this.drawMaxTitleFn(ctx, '方案参考', 1115, '#333')


const twoY = 1160 

this.fillRoundRect(ctx, 25, twoY, 700, rectangle2H, 8, '#fff')

const timeLineX = 210 
const yearSpace = 90 
const circleWidth = 19 
const timeLineH = 100 
const ClipTextLen = 20 

const oneYearY = twoY + 40

ctx.font = 'normal 26px  sans-serif'
ctx.fillStyle = '#999'
ctx.fillText('第一年', textStartX, oneYearY)
this.drawCircleFn(
ctx,
180,
oneYearY + 10,
'#DEDEDE',
circleWidth,
timeLineH,
)
ctx.fillStyle = '#333'
ctx.fillText(
'每月' + monthIntoNum + '元定投购买',
timeLineX,
oneYearY,
)
ctx.fillText(this.yearProductList[0][0], timeLineX, oneYearY + 38)

if (this.yearProductList.length >= 2) {
var Year2Y = oneYearY + yearSpace + 35
ctx.font = 'normal 26px  sans-serif'
ctx.fillStyle = '#999'
ctx.fillText('第二年', textStartX, Year2Y)
this.drawCircleFn(
ctx,
180,
Year2Y + 10,
'#DEDEDE',
circleWidth,
timeLineH + 150,
)
ctx.fillStyle = '#333'
ctx.fillText(
'每月' + monthIntoNum + '元定投购买',
timeLineX,
Year2Y,
)
ctx.fillText(this.yearProductList[1][0], timeLineX, Year2Y + 38)


if (this.yearProductList[1].length > 1) {
ctx.fillText(
'将收益+本金' +
this.allData.list[1].BankFinancingInvestment +
'元投入',
timeLineX,
Year2Y + 50 + 35,
)





ctx.fillText(
this.strToArr(this.yearProductList[1][1])[0],
timeLineX,
Year2Y + 90 + 35,
)


ctx.fillText(
this.strToArr(this.yearProductList[1][1])[1],
timeLineX,
Year2Y + 130 + 35,
)
}
}

if (this.yearProductList.length >= 3) {

var Year3Y = Year2Y + 225 + 35
ctx.font = 'normal 26px  sans-serif'
ctx.fillStyle = '#999'
ctx.fillText('第三年', textStartX, Year3Y)
this.drawCircleFn(
ctx,
180,
Year3Y + 10,
'#DEDEDE',
circleWidth,
timeLineH + 280,
)
ctx.fillStyle = '#333'
ctx.fillText(
'每月' + monthIntoNum + '元定投购买',
timeLineX,
Year3Y,
)
ctx.fillText(this.yearProductList[2][0], timeLineX, Year3Y + 38)

ctx.fillText(
'将收益+本金' +
this.allData.list[2].BankFinancingInvestment +
'元投入',
timeLineX,
Year3Y + 50 + 35,
)

ctx.fillText(
this.strToArr(this.yearProductList[2][1])[0],
timeLineX,
Year3Y + 50 + 35 + 40,
)
ctx.fillText(
this.strToArr(this.yearProductList[2][1])[1],
timeLineX,
Year3Y + 90 + 35 + 40,
)

ctx.fillText(
'将收益+本金' +
this.allData.list[2].StructuredDeposits +
'元投入',
timeLineX,
Year3Y + 185 + 40 - 10,
)
ctx.fillText(
this.strToArr(this.yearProductList[2][2])[0],
timeLineX,
Year3Y + 225 + 40 - 10,
)
let name = this.strToArr(this.yearProductList[2][2])[1]
let pName = name
if (Util.strLength(name) > ClipTextLen * 2) {
pName = name.substr(0, ClipTextLen)
var pName2 = name.substr(ClipTextLen)
ctx.fillText(pName2, timeLineX, Year3Y + 265 + 40 - 10 + 35)
}
ctx.fillText(pName, timeLineX, Year3Y + 265 + 40 - 10)
}

var Year6Y = Year3Y

for (var index = 3; index < this.yearProductList.length; index++) {

const arrIdx = index

var Year6Y = Year6Y + 360 + 38
ctx.font = 'normal 26px  sans-serif'
ctx.fillStyle = '#999'

let yearDesc = this.allData.list[arrIdx].YearDesc

let yearName = yearDesc
if (yearDesc.includes('-')) {
let arr = yearDesc.split('-')
yearName = arr[0]
let yearName2 = arr[1]

ctx.fillText('~', textStartX + 33, Year6Y + 40)
ctx.fillText(yearName2, textStartX, Year6Y + 80)
}

ctx.fillText(yearName, textStartX, Year6Y)




this.drawCircleFn(
ctx,
180,
Year6Y + 10,
'#DEDEDE',
circleWidth,
timeLineH + 280,
)
ctx.fillStyle = '#333'
ctx.fillText(
'每月' + monthIntoNum + '元定投购买',
timeLineX,
Year6Y,
)
ctx.fillText(
this.yearProductList[arrIdx][0],
timeLineX,
Year6Y + 38,
)

ctx.fillText(
'将收益+本金' +
this.allData.list[arrIdx].BankFinancingInvestment +
'元投入',
timeLineX,
Year6Y + 50 + 35,
)

ctx.fillText(
this.strToArr(this.yearProductList[arrIdx][1])[0],
timeLineX,
Year6Y + 50 + 35 + 40,
)
ctx.fillText(
this.strToArr(this.yearProductList[arrIdx][1])[1],
timeLineX,
Year6Y + 90 + 35 + 40,
)

ctx.fillText(
'将收益+本金' +
this.allData.list[arrIdx].StructuredDeposits +
'元投入',
timeLineX,
Year6Y + 185 + 40 - 10,
)
ctx.fillText(
this.strToArr(this.yearProductList[arrIdx][2])[0],
timeLineX,
Year6Y + 225 + 40 - 10,
)

let name = this.strToArr(this.yearProductList[arrIdx][2])[1]
let pName = name
if (Util.strLength(name) > ClipTextLen * 2) {
pName = name.substr(0, ClipTextLen)
var pName2 = name.substr(ClipTextLen)
ctx.fillText(pName2, timeLineX, Year6Y + 265 + 40 - 10 + 35)
}

ctx.fillText(pName, timeLineX, Year6Y + 265 + 40 - 10)

}


ctx.fillStyle = '#666'
ctx.font = 'normal 25px  sans-serif'
ctx.textAlign = 'center'
ctx.fillText(
'本结果仅供参考，请结合自身情况进行投资选择',
this.canvasW / 2,
canvasH - 60,
)


this.overUrl = myCanvas.toDataURL('image/jpeg')
this.$vux.loading.hide()
this.isOverPicShows = true

}
}
}
},

drawCharts() {
const colors = ['#54A0E7', '#EF7777', '#F1A15A']

let i = 0
this.myChart = echarts.init(this.$refs.myChart)
const _this = this

this.myChart.setOption({




legend: {
orient: 'vertical',
left: 'left',
data: ['基金收益', '结构性存款收益', '理财收益'],
},
series: [
{
name: '收益组合',
type: 'pie',
radius: ['30%', '55%'],

avoidLabelOverlap: false,
minAngle: 35,

data: [
{
value: _this.jijinIncome,
name: '基金收益\n' + _this.jijinIncome + '元',
},
{
value: _this.jiegouIncome,
name: '结构性\n存款收益\n' + _this.jiegouIncome + '元',
},
{
value: _this.licaiIncome,
name: '理财收益\n' + _this.licaiIncome + '元',
},
],
itemStyle: {
normal: {


color: function() {
return colors[i++]
},
},










},







},
],
})
},
topAboutFn() {
this.$router.push({
name: 'about',
query: {
type: 2,
},
})
},
drawPicBtn() {
this.drawPicFn()
},
drawMaxTitleFn(ctx, text, Y, color) {

ctx.beginPath()
ctx.textBaseline = 'alphabetic'
ctx.font = 'bold 38px  sans-serif'
ctx.fillStyle = color || '#fff'
ctx.textAlign = 'center'
const title1Y = Y || 300
ctx.fillText(text, this.canvasW / 2, title1Y)

const lineW = 80
const lineX = 205
ctx.moveTo(lineX, title1Y - 15) 
ctx.lineTo(lineX + lineW, title1Y - 15) 
ctx.lineWidth = 3 
ctx.strokeStyle = color || '#fff' 
ctx.stroke()

ctx.moveTo(460, title1Y - 15) 
ctx.lineTo(460 + lineW, title1Y - 15) 
ctx.stroke()
ctx.closePath()

ctx.textBaseline = 'top'
ctx.textAlign = 'left'
},
drawCircleFn(cxt, X, Y, color, w, lineH) {


cxt.beginPath()
cxt.arc(X, Y, w / 2, 0, 360, false)
cxt.lineWidth = 1
cxt.strokeStyle = color
cxt.stroke() 
cxt.closePath()

cxt.beginPath()
cxt.arc(X, Y, w / 2, 0, 360, false)
cxt.fillStyle = color 
cxt.fill() 
cxt.closePath()

cxt.beginPath()
cxt.arc(X, Y, w / 2, 0, 360, false)
cxt.fillStyle = color
cxt.fill()
cxt.strokeStyle = color
cxt.stroke()
cxt.closePath()

const lineHeight = lineH || 100

cxt.beginPath()
cxt.moveTo(X, Y - 25) 
cxt.lineTo(X, Y + lineHeight) 
cxt.lineWidth = 3 
cxt.strokeStyle = color || '#DEDEDE' 
cxt.stroke()
cxt.closePath()
},
drawRoundRectPath(cxt, width, height, radius) {
cxt.beginPath(0)

cxt.arc(width - radius, height - radius, radius, 0, Math.PI / 2)


cxt.lineTo(radius, height)


cxt.arc(radius, height - radius, radius, Math.PI / 2, Math.PI)


cxt.lineTo(0, radius)


cxt.arc(radius, radius, radius, Math.PI, (Math.PI * 3) / 2)


cxt.lineTo(width - radius, 0)


cxt.arc(width - radius, radius, radius, (Math.PI * 3) / 2, Math.PI * 2)


cxt.lineTo(width, height - radius)
cxt.closePath()
},
strokeRoundRect(cxt, x, y, width, height, radius, lineWidth, strokeColor) {


if (2 * radius > width || 2 * radius > height) {
return false
}

cxt.save()
cxt.translate(x, y)

this.drawRoundRectPath(cxt, width, height, radius)
cxt.lineWidth = lineWidth || 2 
cxt.strokeStyle = strokeColor || '#fff'
cxt.stroke()
cxt.restore()
},
fillRoundRect(cxt, x, y, width, height, radius, fillColor) {

if (2 * radius > width || 2 * radius > height) {
return false
}

cxt.save()
cxt.translate(x, y)

this.drawRoundRectPath(cxt, width, height, radius)
cxt.fillStyle = fillColor || '#fff' 
cxt.fill()
cxt.restore()
},
closeOverPicDialogFn() {
this.isOverPicShows = false
},
getChangeSwipeFn(data) {


this.getSwiperData = data
const datas = data.data

this.yearIncomeChildArr[datas.yearIdx][
datas.swipeIdx
] = this.allData.list[datas.yearIdx].Detail[datas.swipeIdx][
data.idx
].Income


this.yearProductList[datas.yearIdx][datas.swipeIdx] = this.yearProductArr[
datas.yearIdx
][datas.swipeIdx][data.idx]




let jijinIncome = 0
let licaiIncome = 0
let jiegouIncome = 0
this.yearIncomeChildArr.forEach((item, idx) => {

let sumNum = item.reduce((prev, cur) => {

return +(+prev + +cur)
})
let overSumNum = sumNum.toFixed(2)
this.$set(this.yearIncomeList, idx, overSumNum)


item.forEach((el, key) => {
if (key === 0) {
jijinIncome += el
}
if (key === 1) {
licaiIncome += el
}
if (key === 2) {
jiegouIncome += el
}
















})


})


this.licaiIncome = licaiIncome.toFixed(2)
this.jiegouIncome = jiegouIncome.toFixed(2)
this.jijinIncome = jijinIncome.toFixed(2)
this.drawCharts()



let sumFinalIncomeVal = this.yearIncomeList.reduce((prev, cur) => {
return +prev + +cur

})


this.sumFinalIncome = (+sumFinalIncomeVal).toFixed(2)

let DepositAmountNumval =
this.allData.TargetDuration * 12 * this.allData.MonthlyDeposit +
+this.sumFinalIncome
this.DepositAmountNum = DepositAmountNumval.toFixed(2)



















this.swperDepositIncomeList[datas.yearIdx][
datas.swipeIdx
] = this.DepositChildArr[datas.yearIdx][datas.swipeIdx][data.idx]

this.swperDepositIncomeList[datas.yearIdx].forEach((item, idx) => {})

let swperDepositVal = this.swperDepositIncomeList[datas.yearIdx].reduce(
(total, currentValue, currentIndex, arr) => {

return +total + +currentValue
},
0,
)
this.DepositAmountArr[datas.yearIdx] = (
+this.fixedDepositAmountArr[datas.yearIdx] + swperDepositVal
).toFixed(2)



































},
strToArr(str, symbol = '&') {
return str.split(symbol)
},
changePopupShowFn(idx) {
this.popupObj.jijin = this.yearIncomeChildArr[idx][0]
this.popupObj.licai = this.yearIncomeChildArr[idx][1]
this.popupObj.jiegou = this.yearIncomeChildArr[idx][2]





this.popupShow = true
},
},
}



// WEBPACK FOOTER //
// ./src/pages/planResult.vue